import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import React from 'react';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import IcQMark from '../components/icons/IcQMark.js';
import { FOOTER_TYPE, FOOTER_QUICK_MENU_TITLE } from './footer.js';
import { URL } from './url.js';
import COLOR from '../foundation/color.js';

var FOOTER_QUICK_MENU_ITEM_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FOOTER_TYPE.MY_ASSET, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FOOTER_QUICK_MENU_TITLE.SHOPPING_PAY_HELP, {
  title: FOOTER_QUICK_MENU_TITLE.SHOPPING_PAY_HELP,
  href: URL.SHOPPING_PAY_HELP
}), FOOTER_QUICK_MENU_TITLE.TERMS_POLICY, {
  title: FOOTER_QUICK_MENU_TITLE.TERMS_POLICY,
  href: URL.TERMS_POLICY
}), FOOTER_QUICK_MENU_TITLE.PRIVACY, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}), FOOTER_QUICK_MENU_TITLE.CREDIT_INFO_USAGE, {
  title: FOOTER_QUICK_MENU_TITLE.CREDIT_INFO_USAGE,
  href: URL.CREDIT_INFO_USAGE
}), FOOTER_QUICK_MENU_TITLE.NPAY_AD_POINT, {
  title: FOOTER_QUICK_MENU_TITLE.NPAY_AD_POINT,
  href: URL.NPAY_AD_POINT
})), FOOTER_TYPE.PAYMENT, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FOOTER_QUICK_MENU_TITLE.SHOPPING_PAY_HELP, {
  title: FOOTER_QUICK_MENU_TITLE.SHOPPING_PAY_HELP,
  href: URL.SHOPPING_PAY_HELP
}), FOOTER_QUICK_MENU_TITLE.TERMS_POLICY, {
  title: FOOTER_QUICK_MENU_TITLE.TERMS_POLICY,
  href: URL.TERMS_POLICY
}), FOOTER_QUICK_MENU_TITLE.PRIVACY, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}), FOOTER_QUICK_MENU_TITLE.CREDIT_INFO_USAGE, {
  title: FOOTER_QUICK_MENU_TITLE.CREDIT_INFO_USAGE,
  href: URL.CREDIT_INFO_USAGE
}), FOOTER_QUICK_MENU_TITLE.NPAY_AD_POINT, {
  title: FOOTER_QUICK_MENU_TITLE.NPAY_AD_POINT,
  href: URL.NPAY_AD_POINT
})), FOOTER_TYPE.SAVINGS, _defineProperty(_defineProperty({}, FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION, {
  title: FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION,
  tooltipInfo: {
    icon: /*#__PURE__*/React.createElement(IcQMark, {
      width: 16,
      height: 16,
      fill: COLOR.gray700.color
    }),
    contents: [{
      title: FOOTER_QUICK_MENU_TITLE.INDEMNIFICATION_PROVISION,
      description: ( /*#__PURE__*/React.createElement(React.Fragment, null, "\uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uC774 \uC81C\uACF5\uD558\uB294 \uAE08\uC735\uC815\uBCF4\uB294 \uAC01 \uCEE8\uD150\uCE20 \uC81C\uACF5\uC5C5\uCCB4\uB85C\uBD80\uD130 \uBC1B\uB294 \uC815\uBCF4\uB85C \uD22C\uC790 \uCC38\uACE0\uC0AC\uD56D\uC774\uBA70, \uC624\uB958\uAC00 \uBC1C\uC0DD\uD558\uAC70\uB098 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uB124\uC774\uBC84\uD30C\uC774\uB0B8\uC15C(\uC8FC)\uC740 \uC81C\uACF5\uB41C \uC815\uBCF4\uC5D0 \uC758\uD55C \uD22C\uC790\uACB0\uACFC\uC5D0 \uBC95\uC801\uCC45\uC784\uC744 \uC9C0\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uAC8C\uC2DC\uB41C \uC815\uBCF4\uB294 \uBB34\uB2E8\uC73C\uB85C \uBC30\uD3EC\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."))
    }]
  }
}), FOOTER_QUICK_MENU_TITLE.SAVINGS_INTEREST_RATE_INFO, {
  title: FOOTER_QUICK_MENU_TITLE.SAVINGS_INTEREST_RATE_INFO,
  href: URL.SAVINGS_INTEREST_RATE_INFO
})), FOOTER_TYPE.LOAN, _defineProperty({}, FOOTER_QUICK_MENU_TITLE.LOAN_SOLICITATION_TERMS, {
  title: FOOTER_QUICK_MENU_TITLE.LOAN_SOLICITATION_TERMS,
  href: URL.LOAN_SOLICITATION_TERMS
})), FOOTER_TYPE.STOCK, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FOOTER_QUICK_MENU_TITLE.STOCK_NOTICE, {
  title: FOOTER_QUICK_MENU_TITLE.STOCK_NOTICE,
  href: URL.STOCK.NOTICE
}), FOOTER_QUICK_MENU_TITLE.STOCK_HELP, {
  title: FOOTER_QUICK_MENU_TITLE.STOCK_HELP,
  href: URL.STOCK.HELP
}), FOOTER_QUICK_MENU_TITLE.TERMS_POLICY, {
  title: FOOTER_QUICK_MENU_TITLE.TERMS_POLICY,
  href: URL.TERMS_POLICY
}), FOOTER_QUICK_MENU_TITLE.PRIVACY, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}), FOOTER_QUICK_MENU_TITLE.STOCK_ERROR_REPORT, {
  title: FOOTER_QUICK_MENU_TITLE.STOCK_ERROR_REPORT,
  href: URL.STOCK.ERROR_REPORT
}), FOOTER_QUICK_MENU_TITLE.ARTICLE_ARRANGEMENT_MANAGER, {
  title: FOOTER_QUICK_MENU_TITLE.ARTICLE_ARRANGEMENT_MANAGER
}), FOOTER_QUICK_MENU_TITLE.JUVENILE_PROTECTION_MANAGER, {
  title: FOOTER_QUICK_MENU_TITLE.JUVENILE_PROTECTION_MANAGER
})), FOOTER_TYPE.REAL_ESTATE, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_HELP, {
  title: FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_HELP,
  href: URL.REAL_ESTATE_HELP
}), FOOTER_QUICK_MENU_TITLE.NAVER_FINANCIAL_TERMS_POLICY, {
  title: FOOTER_QUICK_MENU_TITLE.NAVER_FINANCIAL_TERMS_POLICY,
  href: URL.TERMS_POLICY
}), FOOTER_QUICK_MENU_TITLE.PRIVACY, {
  title: FOOTER_QUICK_MENU_TITLE.PRIVACY,
  isBold: true,
  href: URL.PRIVACY
}), FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_OPEN_SOURCE_LICENSE, {
  title: FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_OPEN_SOURCE_LICENSE,
  href: URL.REAL_ESTATE_OPEN_SOURCE_LICENSE
}), FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_COMPLEX_EDIT_SUGGESTION, {
  title: FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_COMPLEX_EDIT_SUGGESTION,
  href: URL.REAL_ESTATE_COMPLEX_EDIT_SUGGESTION
}), FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_COMPLEX_NEW_REQUEST, {
  title: FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_COMPLEX_NEW_REQUEST,
  href: URL.REAL_ESTATE_COMPLEX_NEW_REQUEST
}), FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_INSURANCE_HELP, {
  title: FOOTER_QUICK_MENU_TITLE.REAL_ESTATE_INSURANCE_HELP,
  href: URL.REAL_ESTATE_INSURANCE_HELP
}), FOOTER_QUICK_MENU_TITLE.ARTICLE_ARRANGEMENT_MANAGER, {
  title: FOOTER_QUICK_MENU_TITLE.ARTICLE_ARRANGEMENT_MANAGER
}), FOOTER_QUICK_MENU_TITLE.JUVENILE_PROTECTION_MANAGER, {
  title: FOOTER_QUICK_MENU_TITLE.JUVENILE_PROTECTION_MANAGER
}));

export { FOOTER_QUICK_MENU_ITEM_MAP };
